import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import React, { Fragment, useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Routes } from 'Utils';
import { useHistory, useParams } from 'react-router-dom';
import { activateEmail } from 'ReduxStore/profile/Action';
import { useDispatch } from 'react-redux';

interface RouteParams {
	token: string;
}

interface EmailSentProps extends RouteComponentProps {
	email?: string | undefined;
}
const EmailActivated = ({ email, history }: EmailSentProps) => {
	const params = useParams<RouteParams>();
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(activateEmail(params.token))
	}, [])
	return (
		<Fragment>
			<ConditionalCard
				information={`Email successfully confirmed.`}
				heading={`You have successfully confirmed your account`}
				conditions={[
					{
						id: 1,
						name: 'Login',
					},
				]}
				common = {{background:'#d4d4d4'}}
				onClick={() => history.push(Routes.Login)}
			/>
		</Fragment>
	);
};

export default withRouter(EmailActivated);
